class HeroBannerSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    this.elements = {
      slider: this.querySelector(".hero-banner-slider"),
    };
  }

  connectedCallback() {
    this.initSlider();
  }

  initSlider() {
    if (!window.Splide || !this.elements.slider) return;

    this.slider = new window.Splide(this.elements.slider, {
      type: this.getAttribute("data-slider-type"),
      arrows: this.getAttribute("data-enable-arrows") === "true",
      pagination: this.getAttribute("data-enable-pagination") === "true",
      autoplay: this.getAttribute("data-enable-autoplay") === "true",
      interval: parseFloat(this.getAttribute("data-autoplay-speed")),
    }).mount();
  }
}

if (!customElements.get("hero-banner-slider")) {
  customElements.define("hero-banner-slider", HeroBannerSlider);
}
